import { BaseRepository } from "@/repositories/base-repository"
import type { IInstructionFeedbackActivity } from "@/interfaces/api/instruction-feedback-activity.interface"

export class InstructionFeedbackActivityRepository extends BaseRepository<IInstructionFeedbackActivity> {
  protected resourcePath = "planning/instruction-feedbacks-activities"
}
